{register} = require 'src/js/infrastructure/setup-registry'

setup = ($ctx) ->
    $grid = $ctx.find('#stations').staticgrid()[0]
    $grid.table.order([[2, 'desc'], [0, 'asc'], [1, 'asc']]).draw()

register 'App.MyRTKBase.Administration.OrderBaseGrid.Setup', setup